// import { analyticsV4 } from '@cld/analytics';
// import { AnalyticsLevels } from './analytics.constants';
import { parse as parseQs } from 'qs';

// eslint-disable-next-line no-unused-vars
export const sendAnalytics = (levels, eventName) => {
  // analyticsV4({ eventName, levels: [AnalyticsLevels.upload_widget, ...levels] });
};

export const getUWLocation = (url) => {
  const CLD_CONSOLE_RGX = /(dev|demo)?\.?cloudinary\.com$/;
  const { pmHost } = parseQs(url, { ignoreQueryPrefix: true });
  return pmHost && String(pmHost).match(CLD_CONSOLE_RGX) ? 'assets' : 'modal';
};

const uwLocation = getUWLocation(self.location.search);

export const createAnalyticsPageviewEventName = (tabSrc) => `ga-${uwLocation}-pageview-upload_widget-${tabSrc}`;

export const createAnalyticsClickEventName = (tabSrc) => `ga-${uwLocation}-click_button-upload_widget-${tabSrc}-upload`;

export const createAnalyticsAdvancedEventName = (advancedControl) => `ga-${uwLocation}-click_button-upload_widget-advanced-${advancedControl}`;
